import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	itemManageQueuesNewLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.practice-queues.manage-queues-item.item-manage-queues-new-lozenge',
		defaultMessage: 'New',
		description: 'New lozenge shown next to Queue settings button',
	},
});
